<template>
    <div>
        <div class="header-return">
            <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap"
                     :size="GCONFIG.styleElFormSize">
                <el-form-item label="开始日期">
                    <el-date-picker
                            v-model=formInline.start
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="结束日期">
                    <el-date-picker
                            v-model=formInline.end
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getPromotionOrderNum">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <el-row :gutter="20">
            <el-table :data="orderList" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading"
            >
                <el-table-column prop="PROMOTION_NAME" label="促销名称" width="250"></el-table-column>
                <el-table-column prop="CREATE_TIME" label="日期" width="250"></el-table-column>
                <el-table-column prop="orderNum" label="订单数"></el-table-column>
            </el-table>
            <div class="pagination-wrap">
                <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="formInline.currentPage"
                        :page-sizes="GCONFIG.pageSizes"
                        :page-size="formInline.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="formInline.recordsTotal">
                </el-pagination>
            </div>
        </el-row>
    </div>
</template>
<script>
    //导入 HTTP请求方法
    import {
        getPromotionOrder
    } from '../../api/api';
    export default {
        data() {
            return {
                loading: true,
                orderList: [],
                formInline: {
                    promotionId: '',
                    start: '',
                    end: '',
                    currentPage: 1,
                    pageSize: 10,
                    recordsTotal: 0
                }
            }
        },
        //挂载时候执行
        mounted(){
            this.formInline.promotionId = this.$route.query.promotionId;
            //初始化首页数据
            this.getPromotionOrderNum();
        },
        methods: {
            getPromotionOrderNum(){
                this.loading = true;
                getPromotionOrder(this.formInline).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.orderList = res.data.value;
                        this.formInline.recordsTotal = res.data.value.total;
                    } else {
                        this.$message({
                            showClose: true,
                            message: '系统错误，请联系管理员',
                            type: 'error'
                        });
                    }
                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getPromotionOrderNum();
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getPromotionOrderNum();
            },
            returnHistory(){
                window.history.back()
            }
        }
    }
</script>
<style>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>


// WEBPACK FOOTER //
// src/views/promotion/promotionOrder.vue